import { v4 as uuidv4 } from "uuid";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiTuyenSinhTab } from "../../../model/request/thu-phi-tuyen-sinh/IThuPhiTuyenSinhTab";
import { IThuPhiTuyenSinhReducer } from "../../reducer-model/thu-phi-tuyen-sinh/IThuPhiTuyenSinhReducer";
import { IThuPhiTuyenSinhActionTypes } from "../../action-types/thu-phi-tuyen-sinh/IThuPhiTuyenSinhActionTypes";
import { IMucThuTuyenSinhViewModel } from "../../../model/respone/chung-tu-tuyen-sinh/IMucThuTuyenSinhViewModel";

const iniTab: IThuPhiTuyenSinhTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuTuyenSinhs: [],
  mucThuTuyenSinhSelectedIds: [],
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    chiTuBienLaiId: 0,
  },
};
const iniState: IThuPhiTuyenSinhReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiTuyenSinhReducer = (
  state: IThuPhiTuyenSinhReducer = iniState,
  action: IThuPhiTuyenSinhActionTypes
): IThuPhiTuyenSinhReducer => {
  switch (action.type) {
    case "THU_PHI_TUYEN_SINH_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.thiSinh?.id_thi_sinh === action.payload?.id_thi_sinh &&
          g.thongTinBienLai.bienLaiId <= 0
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                thiSinh: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_TUYEN_SINH_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_TUYEN_SINH_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_TUYEN_SINH_LOAD_MUC_THU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_LOAD_MUC_THU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuTuyenSinhs: action.payload.data,
              mucThuTuyenSinhSelectedIds: [],
              hinhThucNops: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_LOAD_MUC_THU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuTuyenSinhs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGE_MUC_THU_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuTuyenSinhSelectedIds.includes(item)
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuTuyenSinhSelectedIds: action.payload.data,
              mucThuTuyenSinhs: t.mucThuTuyenSinhs.map((g) => {
                if (action.payload.data.includes(g.id_thu_chi)) {
                  if (muc_thu_selected_id_news?.includes(g.id_thu_chi)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(g.so_tien_con_lai),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuTuyenSinhSelectedIds: [
                ...t.mucThuTuyenSinhSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_thu_chi ?? 0)
                ),
                action.payload.data > 0
                  ? action.payload.request?.id_thu_chi ?? 0
                  : 0,
              ],
              mucThuTuyenSinhs: [
                ...t.mucThuTuyenSinhs.map((mtk: IMucThuTuyenSinhViewModel) => {
                  if (mtk.id_thu_chi === action.payload.request.id_thu_chi) {
                    return {
                      ...mtk,
                      so_tien_thuc_nop: action.payload.data,
                    };
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuTuyenSinhs: [],
                mucThuTuyenSinhSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TUYEN_SINH_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.thiSinh?.id_thi_sinh === action.payload.request.id_thi_sinh) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
